/* @flow */

import {
  baseFontSize,
  baseLineHeight,
} from '@braindate/ui/lib/token/typography';

export default {
  ':root': {
    // Width and height properties includes content, padding and border, but not
    // the margin
    boxSizing: 'border-box',

    fontSize: baseFontSize,
    lineHeight: baseLineHeight / baseFontSize,
    // Prevent adjustments of font size after orientation changes in iOS
    WebkitTextSizeAdjust: '100%',
  },
};
